import React from 'react';
import PageDirectory from '../components/PageDirectory';
import { STUDY_PAGES } from '../config/studyPages';

// Directory of the studies and comparisons, split out of Home. The list and
// the card markup live elsewhere; this file only names the page.
function Studies() {
  return (
    <PageDirectory
      title="Brookline Notepad Studies"
      pages={STUDY_PAGES}
      emptyText="You do not have access to any of the studies yet."
      disclaimer={<p>Each study carries its own disclaimer and source information.</p>}
    />
  );
}

export default Studies;
